import { render, staticRenderFns } from "./MaterialSnRuleList.vue?vue&type=template&id=542f9800&"
import script from "./MaterialSnRuleList.vue?vue&type=script&lang=js&"
export * from "./MaterialSnRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports